define('item_relations_row.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('item_relations_row', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<ul class=\"item-relations-row\" data-type=\"carousel-items\"><div data-type=\"backbone.collection.view.cells\"></div></ul>  ";
},"useData":true}, 'extensions/SC/Posh/3.5.5/', 'extensions/SC/Posh/3.5.5/', Handlebars);
});